import { useQuery } from "@tanstack/react-query";
import { api } from "utils/api";

export interface EntityForTheCompanyModel {
    id: string;
    name: string;
    address: string;
}

const fetchEntitiesForTheCompany = async (
    companyId: string | null | undefined
): Promise<EntityForTheCompanyModel[]> => {
    if (!companyId) {
        return [];
    }

    const { data } = await api.get<EntityForTheCompanyModel[]>(
        `/companies/${companyId}/entities`
    );

    return data;
};

export function useEntitiesForTheCompany(companyId: string | null | undefined) {
    return useQuery({
        queryKey: ["entities", companyId],
        queryFn: () => fetchEntitiesForTheCompany(companyId),
        enabled: !!companyId,
    });
}
